// Dashboard.jsx
import React, { Component } from "react";
import TeamSummaryCard from "./TeamSummaryCard";
import { BASE_API, AppToaster, startChampionshipDate } from "../../utils/constants";
import { getSession } from "../../utils/helpers";
import { withRouterParams } from "../../utils/withRouterParams";


class Dashboard extends Component {
    state = { loading: false, error: "", team: null };

    async componentDidMount() {
        const search = new URLSearchParams(
            (this.props.location && this.props.location.search) || ""
        ); const teamSlug = search.get("echipa"); // din URL
        const session = getSession();
        const userId = session?.user?.id;
        const userRole = session?.user?.user_role;
        const orgId = session?.organization?.id;

        if (!userId) {
            this.setState({ error: "Sesiune expirată" });
            return;
        }

        // aceleași parametre ca în AdminDashboard.getTeams
        const now = new Date();
        const today = now.toISOString().slice(0, 10);
        const timeNow = now.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit", hour12: false });
        const from = startChampionshipDate/* importă startChampionshipDate sau calculează  `${now.getFullYear() - 1}-07-01`;*/

        let url = `${BASE_API}/api/admin/teams?userId=${userId}&from=${from}&today=${today}&timeNow=${timeNow}`;
        if (userRole === "superadmin" && orgId) url += `&organizationId=${orgId}`;

        try {
            this.setState({ loading: true });
            const res = await fetch(url);
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Eroare");

            const found = (json.teams || []).find(t => t.slug === teamSlug);
            this.setState({ team: found || null, loading: false });
        } catch (e) {
            AppToaster.show({ message: e.message, intent: "danger" });
            this.setState({ error: e.message, loading: false });
        }
    }

    render() {
        const { loading, error, team } = this.state;
        if (loading) return <p>Se încarcă…</p>;
        if (error) return <p>{error}</p>;
        if (!team) return <p>Nu am găsit echipa.</p>;

        return (
            <div className="p-2-rem p-0-ss">
                <TeamSummaryCard
                    team={team}
                    showActions={false}        // pe dashboard personal nu afișezi icoana de ștergere
                    onClickTitle={undefined}   // sau navigare în altă zonă, dacă vrei
                />
            </div>
        );
    }
}

export default withRouterParams(Dashboard);